import RssFeeds from '../../common/components/rssFeeds';
import CardGroup2 from './cardGroup';

class RssFeeds2 extends RssFeeds {
  constructor() {
    super(...arguments);
    this.cardGroupComponent = CardGroup2;
    this.extraLoadingContainerStyles = { height: '100vh' };
    this.paginateFeed = true;
  }
}

export default RssFeeds2;
